import React from 'react';
import LoginPage from './LoginComponents/LoginPage';

const LoginView = (props) => {
  return <LoginPage {...props} />;
};

export default LoginView;
